// extracted by mini-css-extract-plugin
module.exports = {"database":"Xoonips_database__3fMe6"};